import { useMutation, useQueryClient } from 'react-query';

import { NEWSLETTER_SUBSCRIPTION_KEY } from '../utils/backend-api/newsletters';
import {
  NewsletterSubscriptionParams,
  unsubscribeFromNewsletter,
} from '../utils/backend-api/newsletters';

export default function useUnsubscribeFromNewsletter() {
  const queryClient = useQueryClient();
  const { mutate, data, isLoading, isError } = useMutation(
    async ({ newsletter_id }: NewsletterSubscriptionParams) => {
      await unsubscribeFromNewsletter({ newsletter_id });
      queryClient.invalidateQueries([NEWSLETTER_SUBSCRIPTION_KEY, newsletter_id.toString()]);
    }
  );
  return { mutate, data, isLoading, isError };
}
